/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors } from '@zapier/design-system';

const Styles = {
  root: {
    border: 0,
    height: 5,
    backgroundColor: Colors.gray10,
  },
};

/**
 * Renders a horizontal line.
 */
const Separator = () => <hr css={Styles.root} />;

export default Separator;
